import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Collapse } from '@material-ui/core';
import styled, { css } from 'styled-components';
import { Icon } from 'fpay-ui';

import ConfirmModal from '@components/Modal/ConfirmModal';
import Text from '@components/Text';
import Button from '@components/Forms/Button';
import { breakpoint } from '@constants/styles';

const Container = styled.div`
  padding: 30px 24px;
  flex: 1;
  width: 100%;
  background-color: white;
  margin-bottom: 8px;
  ${breakpoint('medium')`
    padding: 30px 32px;
    border-radius: 6px;
    margin-bottom: 12px;
  `}
`;

const Title = styled(Text)`
  cursor: pointer;
`;
Title.displayName = 'Title';

const CollapseWrapper = styled.div`
  margin-top: 12px;
  ${breakpoint('medium')`
    margin-top: 8px;
  `}
`;

const StyledIcon = styled(Icon)(
  ({ open }) => css`
    cursor: pointer;
    margin-right: 24px;
    vertical-align: bottom;
    pointer-events: none;
    transition: transform 200ms cubic-bezier(0, 0, 0.2, 1) 0ms;
    ${open &&
    css`
      transform: rotate(-180deg);
    `}
  `
);

const StyledButton = styled(Button)(
  css`
    float: right;
    margin-left: 16px;
  `
);

const ListInfoCardContainer = ({
  children,
  title,
  showEdit,
  handleEdit,
  showDelete,
  handleDelete,
}) => {
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  const handleModalOpen = (e) => {
    e.stopPropagation();
    setShowModal(true);
  };

  const handleModalCancel = () => {
    setShowModal(false);
  };

  const handleModalConfirm = () => {
    handleDelete();
    setShowModal(false);
  };

  return (
    <>
      <Container>
        <Title
          data-testid="listinfocardcontainer-title"
          type="Subtitle-1-w500"
          color="gray800"
          onClick={handleOpen}
        >
          <StyledIcon icon="ic-arrow-down" color="gray600" open={open} />
          {title}
          <>
            {showDelete && (
              <StyledButton
                data-testid="listinfocardcontainer-delete-button"
                variant="text"
                onClick={handleModalOpen}
              >
                <Icon icon="ic-delete" />
              </StyledButton>
            )}
            {showEdit && (
              <StyledButton
                data-testid="listinfocardcontainer-edit-button"
                variant="text"
                onClick={handleEdit}
              >
                <Icon icon="ic-edit" />
              </StyledButton>
            )}
          </>
        </Title>
        <Collapse data-testid="listinfocardcontainer-collapse" in={open}>
          <CollapseWrapper>{children}</CollapseWrapper>
        </Collapse>
      </Container>
      {showModal && (
        <ConfirmModal
          data-testid="listinfocardcontainer-modal"
          title="¿Quieres eliminar la cuenta?"
          open={showModal}
          textCancel="Cancelar"
          textConfirm="Eliminar"
          handleCancel={handleModalCancel}
          handleConfirm={handleModalConfirm}
        />
      )}
    </>
  );
};

ListInfoCardContainer.propTypes = {
  title: PropTypes.string.isRequired,
  showEdit: PropTypes.bool,
  handleEdit: PropTypes.func,
  showDelete: PropTypes.bool,
  handleDelete: PropTypes.func,
};

ListInfoCardContainer.defaultProps = {
  showEdit: false,
  handleEdit: undefined,
  showDelete: false,
  handleDelete: undefined,
};

export default ListInfoCardContainer;
